import ReactController from '~/controllers/react_controller'
import AWSPatchManagerDashboardCharts from '~/dashboard/aws_patch_manager_dashboard_charts'

export default class AWSPatchManagerDashboardChartsController extends ReactController {
  static values = {
    organizationId: String,
  }

  createComponent() {
    return <AWSPatchManagerDashboardCharts organizationId={this.organizationIdValue} />
  }
}
